// extracted by mini-css-extract-plugin
export default {"container":"Course_container__sVKxF","title":"Course_title__wzVl9","text":"Course_text__adP0j","tab":"Course_tab__pZ6GS","active":"Course_active__zc0TO"};